import React from "react";

// Decorative wheat stalk SVG — inspired by the gold wheat in Santo Nhoque branding
export const WheatStalk = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 64 120"
    className={className}
    style={{ transform: flip ? "scaleX(-1)" : "none" }}
    aria-hidden="true"
  >
    <g stroke="currentColor" strokeWidth="1.2" fill="currentColor" opacity="0.9">
      <path d="M32 118 L32 14" fill="none" />
      {[14, 26, 38, 50, 62, 74, 86].map((y, i) => (
        <g key={i}>
          <ellipse
            cx={26 - i * 0.4}
            cy={y + i * 1.2}
            rx="3.6"
            ry="6.5"
            transform={`rotate(-30 ${26 - i * 0.4} ${y + i * 1.2})`}
            opacity="0.85"
          />
          <ellipse
            cx={38 + i * 0.4}
            cy={y + i * 1.2}
            rx="3.6"
            ry="6.5"
            transform={`rotate(30 ${38 + i * 0.4} ${y + i * 1.2})`}
            opacity="0.85"
          />
        </g>
      ))}
      <ellipse
        cx="32"
        cy="8"
        rx="3"
        ry="6"
        transform="rotate(0 32 8)"
        opacity="0.85"
      />
    </g>
  </svg>
);

// Vintage circular badge — Santo Nhoque logo recreation
export const BrandSeal = ({ className = "", size = 160 }) => (
  <svg
    viewBox="0 0 200 200"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    <defs>
      <path
        id="topArc"
        d="M 30 100 A 70 70 0 0 1 170 100"
        fill="none"
      />
      <path
        id="bottomArc"
        d="M 170 110 A 70 70 0 0 1 30 110"
        fill="none"
      />
    </defs>
    {/* Outer circle */}
    <circle
      cx="100"
      cy="100"
      r="92"
      fill="none"
      stroke="#D4B87D"
      strokeWidth="1.5"
    />
    {/* Inner double circle */}
    <circle
      cx="100"
      cy="100"
      r="78"
      fill="none"
      stroke="#D4B87D"
      strokeWidth="0.8"
    />
    <circle
      cx="100"
      cy="100"
      r="74"
      fill="none"
      stroke="#D4B87D"
      strokeWidth="0.5"
    />
    {/* Top text */}
    <text fill="#D4B87D" fontSize="13" fontFamily="Playfair Display, serif" letterSpacing="3">
      <textPath href="#topArc" startOffset="50%" textAnchor="middle">
        SANTO NHOQUE
      </textPath>
    </text>
    {/* Bottom text */}
    <text fill="#D4B87D" fontSize="8" fontFamily="Manrope, sans-serif" letterSpacing="4">
      <textPath href="#bottomArc" startOffset="50%" textAnchor="middle">
        MASSAS ARTESANAIS
      </textPath>
    </text>
    {/* Center monogram */}
    <text
      x="100"
      y="92"
      textAnchor="middle"
      fill="#D4B87D"
      fontSize="20"
      fontFamily="Playfair Display, serif"
      fontStyle="italic"
      fontWeight="600"
    >
      Santo
    </text>
    <text
      x="100"
      y="112"
      textAnchor="middle"
      fill="#D4B87D"
      fontSize="20"
      fontFamily="Playfair Display, serif"
      fontStyle="italic"
      fontWeight="600"
    >
      Nhoque
    </text>
    <line x1="70" y1="120" x2="130" y2="120" stroke="#D4B87D" strokeWidth="0.6" />
    <text
      x="100"
      y="135"
      textAnchor="middle"
      fill="#D4B87D"
      fontSize="9"
      fontFamily="Manrope, sans-serif"
      letterSpacing="3"
    >
      DESDE 2015
    </text>
    {/* Side dots */}
    <circle cx="18" cy="100" r="2" fill="#D4B87D" />
    <circle cx="182" cy="100" r="2" fill="#D4B87D" />
  </svg>
);

// Ornamental flourish divider
export const Flourish = ({ className = "" }) => (
  <svg
    viewBox="0 0 200 20"
    className={className}
    aria-hidden="true"
  >
    <g stroke="currentColor" fill="none" strokeWidth="0.8" opacity="0.85">
      <path d="M 0 10 L 70 10" />
      <path d="M 130 10 L 200 10" />
      <circle cx="100" cy="10" r="2.4" fill="currentColor" />
      <path d="M 80 10 Q 90 4, 100 10 Q 110 16, 120 10" />
      <path d="M 80 10 Q 90 16, 100 10 Q 110 4, 120 10" />
      <circle cx="78" cy="10" r="1" fill="currentColor" />
      <circle cx="122" cy="10" r="1" fill="currentColor" />
    </g>
  </svg>
);
